var map = {
	"./1026.jpg": 2487,
	"./13295527_5153829.jpeg": 7090,
	"./13558745_5283458.png": 6303,
	"./16351572_rm209-adj-20.jpg": 8545,
	"./18246003_v915-wit-001.jpg": 8350,
	"./19256531_6106991.jpg": 267,
	"./2344.jpg": 3013,
	"./34012978_black_friday_facebook_banner_02.png": 2097,
	"./4428861.jpg": 3175,
	"./6524364_3306567.jpg": 2945,
	"./6864937_23324.jpg": 8228,
	"./7040910.jpg": 4898,
	"./85333.jpg": 1337,
	"./8767132.jpg": 9063,
	"./Android.png": 7107,
	"./AngularJS.png": 3482,
	"./Azure.png": 9058,
	"./Banner.png": 6321,
	"./Blazor.png": 2040,
	"./Business intelligence.jpg": 9914,
	"./BusinessAnalysis.jpg": 833,
	"./COMMUNICATIONS TECHNOLOGY.jpg": 1088,
	"./CareerBanner.png": 4985,
	"./Cloud (2).jpg": 7676,
	"./Consulting.jpg": 6123,
	"./Data analytics.jpg": 6306,
	"./Datainformation management.jpg": 3739,
	"./Development.jpg": 6411,
	"./DotNet.png": 4714,
	"./Go5050.png": 2751,
	"./Gotaste Logo-13.png": 1476,
	"./Image.png": 7277,
	"./Java.png": 2569,
	"./Kotlin.png": 1792,
	"./Loader.gif": 7238,
	"./Logo-removebg-preview.png": 8013,
	"./Logo-removebg-preview_nobg.png": 3683,
	"./Logo-removebg-preview_old.png": 3438,
	"./Logo-removebg-preview_white.jpg": 3854,
	"./ModinaLogo.png": 8854,
	"./Network_and_cybersecurity.jpg": 4514,
	"./New Products Every Day.gif": 574,
	"./ProcessFour.png": 149,
	"./ProcessOne.png": 88,
	"./ProcessThree.png": 4291,
	"./ProcessTwo.png": 4827,
	"./Python.png": 5306,
	"./React.png": 3749,
	"./S1/Free  Square, Beautiful, Science Background Images, Tech Fashion Cool Background Photo Background PNG and Vectors.jpeg": 3941,
	"./S1/WhatsApp Image 2023-10-14 at 18.03.28_6856b413.jpg": 7823,
	"./S1/p2.jpg": 4250,
	"./S1/s2.png": 7003,
	"./S1/s3.png": 393,
	"./SMKW_logo3.png": 5936,
	"./SMKW_logo3_new.png": 9553,
	"./SQL.png": 7690,
	"./Security technology development.jpg": 5200,
	"./Service.png": 2690,
	"./SoftWareArchitecture development.jpg": 7594,
	"./SproutLogo_big-removebg.png": 605,
	"./SproutLogo_big.jpg": 4392,
	"./Systems integration.jpg": 1197,
	"./Web_development.jpg": 7481,
	"./a.png": 3062,
	"./about-us-removebg-preview.png": 7294,
	"./about-us.jpg": 9180,
	"./about_img.webp": 7761,
	"./application-secuirity.png": 1537,
	"./application.jpg": 3459,
	"./blazor_black.png": 2696,
	"./business-analysis-old-blue.png": 6505,
	"./business-analysis.png": 5545,
	"./business-analysis_multicolor.png": 9680,
	"./business-intelligence.png": 5743,
	"./career.jpg": 8880,
	"./career2.jpg": 7121,
	"./cloud.jpg": 1892,
	"./communication-technology.png": 7920,
	"./consulting.png": 7874,
	"./cybar.jpg": 7706,
	"./cyber-secuirity-threats.png": 8715,
	"./cyber-security.png": 8198,
	"./data-analysis.png": 2309,
	"./data-information-management.png": 708,
	"./data-security.png": 1952,
	"./data_security.jpg": 9551,
	"./development-web-mobile.png": 924,
	"./double-quotes-background.png": 8833,
	"./double-quotes.png": 1549,
	"./e-commerce.png": 6201,
	"./education-system-blue.png": 685,
	"./education-system.png": 6102,
	"./education.png": 5795,
	"./email-security-cloud security.png": 6421,
	"./email.png": 928,
	"./facebook.png": 3639,
	"./favicon.ico": 9315,
	"./favicon.ico.ico": 4978,
	"./feedback.gif": 9611,
	"./food-delivery.png": 2358,
	"./go5050logo2 1.png": 2400,
	"./hack.jpg": 193,
	"./hms.png": 3539,
	"./home_bg.jpg": 6602,
	"./home_bg_old.png": 5089,
	"./hotel-management.png": 7981,
	"./image001.png": 6801,
	"./infastructure.jpg": 3507,
	"./infrastructure-security.png": 5918,
	"./infrastructure.png": 7196,
	"./instagram.png": 8483,
	"./java (1).png": 9548,
	"./joinTeam.png": 7465,
	"./linkedin.png": 6769,
	"./location-icon.png": 5617,
	"./location-pin.png": 7143,
	"./logo (1).png": 1772,
	"./logo.png": 5051,
	"./mobile_development.png": 1493,
	"./ms-sql-server-filled.png": 3538,
	"./ms-sql-server.png": 5697,
	"./my-sql-filled.png": 2748,
	"./navite.svg": 512,
	"./network-cyber-security.png": 4720,
	"./network_-_45961 (360p).mp4": 8660,
	"./office.png": 4916,
	"./offshore-technology.png": 8499,
	"./outsourcing.jpg": 8939,
	"./outsourcing.png": 5208,
	"./pacakage-implementation.png": 9382,
	"./package.jpg": 2985,
	"./pos-system.png": 2004,
	"./process-development.jpg": 4378,
	"./project-delivery.png": 7108,
	"./projectDelivery.jpg": 3534,
	"./rhti-logo.png": 7161,
	"./right-arrow.png": 6611,
	"./security-technology-development.png": 8542,
	"./social-media.png": 7704,
	"./software-application-programming-developer-technology-concept.jpg": 9971,
	"./sproutLogo (1).png": 4868,
	"./sproutLogo (2).png.crdownload": 8131,
	"./sproutLogo.png": 3610,
	"./sq-lite-filled.png": 3143,
	"./sq-lite.png": 2434,
	"./sql-server-black-white.png": 5420,
	"./system-integration.png": 1198,
	"./team2.png": 1331,
	"./team3.png": 1057,
	"./team4.png": 1243,
	"./team5.png": 5452,
	"./team6.png": 2639,
	"./team7.png": 7047,
	"./telephone.png": 8576,
	"./twitter.png": 8019,
	"./web-development-new.png": 9164,
	"./web-development.png": 9637,
	"./whoweare.jpg": 2899,
	"./whoweare.png": 4011
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9536;